export default __webpack_public_path__ + "static/media/prm-club-deal.22ae1116.png";